import { TaskDefinition } from './tasks';

export type Asset = {
  id?: string;
  type: string;
  subtype?: string;
  name: string;
  displayName: string | null;
  description: string;
  owner?: string | null;
  organizationId?: string;
  isSystemAsset?: boolean;
  user_tags: string[] | null;
  properties: { [key: string]: any };
  created?: string;
  modified?: string;
};

export type Relation = {
  id: string;
  type: string;
  organizationId: string;
  fromAsset: Asset;
  toAsset: Asset;
};

export interface TpTemplateInfo {
  scope: string;
  templateType: string;
  name: string;
  displayName?: string;
  version?: string;
  yamlString: string;
  isActive: boolean;
  isSystem: boolean;
  isDefault: boolean;
  assetId?: string; // only present when the template is associated with an asset

  // only present when the template is already stored in the database
  id?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface TpTemplateUpdateInfo {
  yamlString?: string;
  displayName?: string;
  version?: string;
  isActive?: boolean;
  isDefault?: boolean;
}

export const templateScopeMapper = (scope: string): string => {
  if (scope === 'ontologies') {
    return 'ontology';
  } else if (scope === 'assetViews') {
    return 'asset';
  } else if (scope === 'dashboardTemplates') {
    return 'dashboard';
  } else if (scope === 'entityViews') {
    return 'entity';
  } else {
    throw new Error(`Unsupported template scope: ${scope}`);
  }
};

export type Template = {
  ontologies: { [key: string]: TpTemplateInfo[] };
  assetViews: { [key: string]: TpTemplateInfo[] };
  dashboardTemplates: { [key: string]: TpTemplateInfo[] };
  entityViews: { [key: string]: TpTemplateInfo[] };
  startPageViews: { [key: string]: TpTemplateInfo[] };
  uploadTemplates: { [key: string]: TpTemplateInfo[] };
  taskTemplates?: TaskDefinition[];
  [key: string]: any;
};

export type Ontology = {
  assetTypes: { [key: string]: any };
  entityTypes: { [key: string]: any };
};

export type AssetView = {
  assetviewElements: { [key: string]: any };
};

export type StartPageView = {
  startPageElements: { [key: string]: any };
};

//Template for rendering a single entity
export type SingleEntityTemplate = {
  entityType: string;
  displayName: string;
  titleProperty?: string;
  elements: any[]; // rendering elements of the template
};

export type EntityView = {
  assetType: string;
  templateId: string;
  version: string;
  displayName: string;
  entities: SingleEntityTemplate[];
};

export type uploadTemplate = {
  id: string;
  uploadType: string;
  displayName: string;
  collectionAssetType: string;
  collectionAssetDisplayNameProperty: string;
  fileSetAssetType: string;
  collectionMetadata: { id: string; name: string; dataType: string; required: boolean }[];
  fileSetMetadata: { id: string; name: string; dataType?: string; required?: boolean; width?: number }[];
  filePatterns: { propertyId: string; patterns: string[] }[];
};
